import { Navigate } from "react-router-dom";
import { BASE_ROUTE } from "@/components/routes/routes";
import { doPreRegister } from "@/services/service-layer/authService";
import OpticksCheckbox from "@/components/ui/OpticksCheckbox/OpticksCheckbox";
import OpticksButton from "@/components/ui/OpticksButton/OpticksButton";
import OpticksInput from "@/components/ui/OpticksInput/OpticksInput";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import { Controller, useForm } from "react-hook-form";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";
import { useLoaderStore } from "@/zustand/loaderStore";

interface Values {
  name: string;
  password: string;
  terms: boolean;
}

const PreRegister = () => {
  const params = new URLSearchParams(location.search);
  if (!params.has("token")) {
    return <Navigate to={BASE_ROUTE} />;
  }
  const token = params.get("token") || "";
  const loading = useLoaderStore((state) => state.loading);
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isSubmitting },
  } = useForm<Values>({
    mode: "onSubmit",
    defaultValues: {
      name: "",
      password: "",
      terms: false,
    },
  });

  return (
    <>
      <OpticksLogo />
      <h2>Finish registration</h2>
      <p>
        You have been invited to join an Opticks account! In order to finish the
        process you need to provide a name so we can address to you and set a
        password.
      </p>
      <p>
        You will be able to login with the email to which you received the
        invitation.
      </p>
      <form
        className="auth-form"
        noValidate={true}
        onSubmit={handleSubmit((data) => {
          doPreRegister({ ...data, token });
        })}
      >
        <div className="fields">
          <Controller
            name="name"
            control={control}
            rules={{ required: "Required" }}
            render={({ field }) => (
              <div>
                <OpticksInput
                  placeholder="Name"
                  type="text"
                  required
                  surface="white"
                  input={field}
                />
                {errors.name && (
                  <span className="form-invalid-message">
                    {errors.name.message}
                  </span>
                )}
              </div>
            )}
          />

          <Controller
            name="password"
            control={control}
            rules={{ required: "Required" }}
            render={({ field }) => (
              <div>
                <OpticksInput
                  placeholder="Password"
                  type="password"
                  required
                  surface="white"
                  input={field}
                />
                {errors.password && (
                  <span className="form-invalid-message">
                    {errors.password.message}
                  </span>
                )}
              </div>
            )}
          />

          <>
            <Controller
              name="terms"
              control={control}
              rules={{
                validate: (value) => value === true || "Required",
              }}
              render={({ field }) => (
                <div>
                  <OpticksCheckbox
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  >
                    <span>
                      I accept the{" "}
                      <OpticksLink
                        href="https://optickssecurity.com/resources/files/OPTICKS_privacy_policy.pdf"
                        label="terms and conditions"
                      />
                    </span>
                  </OpticksCheckbox>

                  {errors.terms && (
                    <span className="form-invalid-message">
                      {errors.terms.message}
                    </span>
                  )}
                </div>
              )}
            />

            <OpticksButton
              type="submit"
              disabled={!isValid || isSubmitting}
              label="Accept invite"
              size="m-wide"
              loading={loading}
            />
          </>
        </div>
      </form>
    </>
  );
};

export default PreRegister;
